import { render, staticRenderFns } from "./newPermissionIcon.vue?vue&type=template&id=7d346bf1&scoped=true"
import script from "./newPermissionIcon.vue?vue&type=script&lang=js"
export * from "./newPermissionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d346bf1",
  null
  
)

export default component.exports